import { EnumItemDto, LogEntryType } from "../../common/enum";
import { createListStore } from "../../common/listStore";
import { of } from "rxjs";

export enum RunType {
    MailOrder = 1,
    Starter = 2,
    Shipment = 3,
    Dunning = 4,
    ManualWriteOff = 5,
    OrderImport = 6,
    Return = 7,
    Payment = 8,
    WriteOff = 9,
    RejectedImportCustomer = 10,
    OrderCycleSkipImport = 11,
    CustomerNoteImport = 12,
    CustomerReactivation = 13,
    MailOrderCopy = 14,
    OrderDelay = 15,
    MailOrderArticleReplace = 16,
    ContOrderDeactivation = 17,
    Gdpr = 18,
    VatUpdate = 19,
    EmailPreferences = 20,
    OnlineReturnBatch = 21
} 

export const runTypes: EnumItemDto[] = [
    { id: RunType.MailOrder, name: "Mail order" },
    { id: RunType.Starter, name: "Starter" },
    { id: RunType.Shipment, name: "Shipment" },
    { id: RunType.Dunning, name: "Dunning" },
    { id: RunType.ManualWriteOff, name: "Manual write-off" },
    { id: RunType.OrderImport, name: "Order import" },
    { id: RunType.Return, name: "Return" },
    { id: RunType.Payment, name: "Payment" },
    { id: RunType.WriteOff, name: "Write-off" },
    { id: RunType.OrderCycleSkipImport, name: "Order cycle skip import" },
    { id: RunType.CustomerNoteImport, name: "Customer note import" },
    { id: RunType.CustomerReactivation, name: "Customer reactivation" },
    { id: RunType.MailOrderCopy, name: "Batch MO copy" },
    { id: RunType.OrderDelay, name: "Batch order delay" },
    { id: RunType.MailOrderArticleReplace, name: "MO article replace" },
    { id: RunType.ContOrderDeactivation, name: "Order deactivation" },
    { id: RunType.Gdpr, name: "GDPR" },
    { id: RunType.VatUpdate, name: "VAT update" },
    { id: RunType.EmailPreferences, name: "Email preferences" },
    { id: RunType.OnlineReturnBatch, name: "Online return batch" }
];

export const useRunTypes = createListStore<EnumItemDto>({ data: of({ items: runTypes, isFetching: false }) });

export interface RunLogEntry {
    id: number;
    time: string;
    type: LogEntryType;
    message: string;
}
